import introJs from 'intro.js';
import commisionImg from './pro_commission.png';
import productAddFavouritesImg from './product_add_favourites.png';
import productSearchImg from './product_search.png';
import productSearchCommissionImg from './product_search_commission.png';
import productSearchFavouritesImg from './product_search_favourites.png';
import newProductSupplierImg from './new_product_supplier.png';

const setComplete = introGroupName => {
  localStorage.setItem(introGroupName, 'done');
};

const startIntro = (introGroupName, optionsCallback) => {
  // return null;
  const doneTour = localStorage.getItem(introGroupName) === 'done';
  if (doneTour) {
    return;
  }
  const intro = introJs();
  // let scrollRestoration = history.scrollRestoration;
  intro.oncomplete(() => {
    setComplete(introGroupName);
    // history.scrollRestoration = scrollRestoration;
  });
  intro.onexit(() => {
    setComplete(introGroupName);
    document.querySelectorAll('.introjs_scroll-top').forEach(el => {
      el.classList.remove('-overflow-hidden');
    });
    // history.scrollRestoration = scrollRestoration;
  });
  const scrollTop = () => {
    window.scrollTo(0, 0);
    document.querySelectorAll('.introjs_scroll-top').forEach(el => {
      el.classList.add('-overflow-hidden');
      el.scrollTo(0, 0);
    });
  };
  introJs().onbeforechange(scrollTop);
  setTimeout(() => {
    intro.setOptions(optionsCallback());
    intro.start();
  }, 300);
  // }
};

const workdeskOnboardingOptions = () => {
  return {
    steps: [
      {
        element: document.querySelector('#project_workdesk_tab'),
        intro:
          'Add all client & project information under the work desk to keep it conveniently stored in one place.',
      },
      {
        element: document.querySelectorAll('#project_chat_tab')[0],
        intro: 'Communicate and share documents with your client on the chat.',
        // position: 'right',
      },
      {
        element: document.querySelectorAll('#project_design_tab')[0],
        intro: 'Access our database of products and create your design here.',
        // position: 'right',
      },
      {
        element: document.querySelectorAll('.project-customer-picker')[0],
        intro: 'Assign the project to your client here.',
        // position: 'right',
      },
    ],
  };
};

export const workdeskOnboarding = () => {
  const introGroupName = 'Workdesk Tour';
  startIntro(introGroupName, workdeskOnboardingOptions);
};
//
// export const clientDesignOnboardingSteps = [
//   {
//     element: '#product-search-form',
//     intro:
//       'Search our curated database here for products.  The simply drag items into the blue space.',
//     position: 'left',
//   },
//   {
//     element: '#add-customer-products',
//     intro: 'You can add customer products here.',
//     position: 'left',
//   },
//   {
//     element: '#filter-trade-suppliers',
//     intro: 'Click the % sign to view trade products with the best commission.',
//     position: 'left',
//   },
//   {
//     element: '.moodboard-medium-product_commission',
//     intro:
//       '<div class="onboarding-message">1Shows the commission you could earn per product.</div><div class="onboarding-image" ></div>',
//     position: 'right',
//   },
//   {
//     element: '#add-customer-products',
//     intro: 'Can’t find what you’re looking for?\n You can add your own products here.',
//     position: 'bottom',
//   },
// ]

const clientDesignOnboarding1Options = () => {
  return {
    steps: [
      {
        element: document.querySelector('.introjs_highlight.-product-search'),
        intro: `<img class="introjs_image -product-search" src="${productSearchImg}"/><div class="introjs_message">Search our curated database here for products.  The simply drag items into the blue space.</div>`,
        position: 'left',
      },
      {
        element: document.querySelector('.introjs_highlight.-customer-product-search'),
        intro: 'You can add customer products here.',
        position: 'left',
      },
      {
        element: document.querySelector('.introjs_highlight.-product-search'),
        intro: `<img class="introjs_image -product-search" src="${productSearchCommissionImg}"/><div class="introjs_message">Click the % sign to view trade products with the best commission.</div>`,
        position: 'left',
      },
      {
        element: document.querySelector('.introjs_highlight.-pro-commission'),
        intro: `<img class="introjs_image -pro-commission" src="${commisionImg}"/><div class="introjs_message">Shows the commission you could earn per product.</div>`,
        position: 'left',
      },
      {
        element: document.querySelector('.introjs_highlight.-add-product'),
        intro: 'Can’t find what you’re looking for?\n You can add your own products here.',
        position: 'bottom',
      },
    ],
  };
};

export const clientDesignOnboarding1 = () => {
  const introGroupName = 'Client Design Tour';
  startIntro(introGroupName, clientDesignOnboarding1Options);
};

const clientDesignOnboarding2Options = () => {
  return {
    steps: [
      {
        element: document.querySelector('.moodboard-alternative-category'),
        intro: 'Drag alternative product suggestions here.',
        position: 'top',
      },
      {
        element: document.querySelector('.moodboard-costbox_commission'),
        intro:
          'The total commission you could earn from the recommended products is displayed here.',
        position: 'top',
      },
    ],
  };
};

export const clientDesignOnboarding2 = () => {
  const introGroupName = 'Added Product Tour';
  startIntro(introGroupName, clientDesignOnboarding2Options);
};

const addProductOnboardingOptions = () => {
  return {
    steps: [
      {
        element: document.querySelector('.introjs_highlight.-product-choose-supplier'),
        intro: `<img class="introjs_image -product-choose-supplier" src="${newProductSupplierImg}"/><div class="introjs_message"> \
          Always select a supplier.  \
          If the supplier doesn’t appear on the list add it on the supplier tab. \
        </div>`,
      },
    ],
  };
};

export const addProductOnboarding = () => {
  const introGroupName = 'Add Product Tour';
  startIntro(introGroupName, addProductOnboardingOptions);
};



// WEBPACK FOOTER //
// ./app/javascript/common/onboarding/onboarding.js